<template>
  <section id="section-1">
    <div class="row close-bottom">
      <div class="col-md-11"></div>
      <div class="col-md-1">
        <router-link to="/profile/dashboard">
          <div title="بازگشت به داشبورد" class="close"></div>
        </router-link>
      </div>
    </div>
    <div class="row profile-earlier">
      <div class="col-md-3 col-sm-6">
        <div class="user-avatar-uploader" v-if="!image">
          <img src="/img/useravatar.png" alt="Image" class="img-fluid" />
          <div class="col-md-2 img-icon" title="افزودن عکس کاربر">
            <label class="upload-bt" for="upload-img" @change="onFileChange">
              <i class="icon-attach"></i>
            </label>
          </div>
        </div>
        <div class="user-avatar-uploader" v-else>
          <img :src="image" class="card bg-white" />
          <div class="col-md-2 img-icon" title="حذف عکس ">
            <i class="fa fa-close" @click="removeImage" style="color: red"></i>
          </div>
        </div>

        <input id="upload-img" type="file" accept="image/*" @change="onFileChange" style="display: none" />
      </div>
      <div class="col-md-3 col-sm-6 profile-earlier-item">
        نام : <span>{{ data.firstName }}</span>
      </div>
      <div class="col-md-3 col-sm-6 profile-earlier-item">
        نام خانوادگی : <span>{{ data.lastName }}</span>
      </div>
      <div class="col-md-3 col-sm-6 profile-earlier-item">
        نام انگلیسی : <span>{{ data.englishName }}</span>
      </div>
      <div class="col-md-3 col-sm-6 profile-earlier-item email">
        پست الکترونیک : <span>{{ data.email }}</span>
      </div>
      <div class="col-md-3 col-sm-6 profile-earlier-item">
        شماره موبایل : <span>{{ data.cellPhoneNumber }}</span>
      </div>
      <div class="col-md-3 col-sm-6 profile-earlier-item">
        کد ملی : <span>{{ data.nationalNumber }}</span>
      </div>
      <div class="col-md-3 col-sm-6 profile-earlier-item">
        نام پدر :
        <span>{{ data.fatherName }}</span>
      </div>
    </div>
    <!-- End row -->

    <form>
      <div class="row">
        <div class="col-md-12">
          <h4>ویرایش اطلاعات شخصی</h4>
        </div>
      </div>
      <!-- End row -->

      <div class="row">
        <div class="col-md-4">
          <div class="group_mdi">
            <input type="text" v-model="data.firstName" @blur="$v.data.firstName.$touch()"
              :class="{ invalid: $v.data.firstName.$error }" />
            <span class="highlight"></span>
            <span class="bar"></span>
            <label><span class="validation-color">*</span> نام</label>
            <p class="text-danger" v-if="!$v.data.firstName.required && $v.data.firstName.$dirty">
              لطفا نام را وارد کنید
            </p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="group_mdi">
            <input v-model="data.lastName" type="text" @blur="$v.data.lastName.$touch()"
              :class="{ invalid: $v.data.lastName.$error }" />
            <span class="highlight"></span>
            <span class="bar"></span>
            <label><span class="validation-color">*</span> نام خانوادگی</label>
            <p class="text-danger" v-if="!$v.data.lastName.required && $v.data.lastName.$dirty">
              لطفا نام خانوادگی را وارد کنید
            </p>
          </div>
        </div>

        <div class="col-md-4">
          <div class="group_mdi">
            <input v-model="data.englishName" type="text"/>
            <span class="highlight"></span>
            <span class="bar"></span>
            <label>نام انگلیسی</label>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <div class="group_mdi">
            <input disabled="true" name="first_name" id="first_name" type="text" v-model="data.email"
              @blur="$v.data.email.$touch()" :class="{ invalid: $v.data.email.$error }" />
            <span class="highlight"></span>
            <span class="bar"></span>
            <label class="special-labels"><span class="validation-color">*</span>پست الکترونیک</label>
            <p class="text-danger" v-if="!$v.data.email.required && $v.data.email.$dirty">
              لطفا پست الکترونیک را وارد کنید
            </p>
            <p class="text-danger" v-if="!$v.data.email.email">
              پست الکترونیک وارد شده معتبر نمیباشد
            </p>
          </div>
        </div>

        <div class="col-md-4">
          <div class="group_mdi">
            <input name="last_name" id="last_name" type="number" v-model="data.cellPhoneNumber"
              @blur="$v.data.cellPhoneNumber.$touch()" :class="{ invalid: $v.data.cellPhoneNumber.$error }"
              maxlength="11" />
            <span class="highlight"></span>
            <span class="bar"></span>
            <label><span class="validation-color">*</span>شماره همراه</label>
            <p class="text-danger" v-if="
              !$v.data.cellPhoneNumber.required &&
              $v.data.cellPhoneNumber.$dirty
            ">
              لطفا شماره همراه را وارد کنید
            </p>
            <p class="text-danger" v-if="
              !$v.data.cellPhoneNumber.minLength &&
              $v.data.cellPhoneNumber.$dirty
            ">
              لطفا شماره همراه را به درستی وارد نمایید
            </p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="group_mdi">
            <input v-model="data.nationalNumber" type="text" @blur="$v.data.nationalNumber.$touch()"
              :class="{ invalid: $v.data.nationalNumber.$error }" />
            <span class="highlight"></span>
            <span class="bar"></span>
            <label><span class="validation-color">*</span>کد ملی</label>
            <p class="text-danger" v-if="
              !$v.data.nationalNumber.required &&
              $v.data.nationalNumber.$dirty
            ">
              لطفا کد ملی را وارد کنید
            </p>

            <p class="text-danger" v-if="
              !$v.data.nationalNumber.checkMelliCode &&
              $v.data.nationalNumber.$dirty
            ">
              لطفا کد ملی را با فرمت صحیح وارد نمائید
            </p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <div class="group_mdi">
            <input type="text" v-model="data.fatherName" />
            <span class="highlight"></span>
            <span class="bar"></span>
            <label>نام پدر</label>
          </div>
        </div>
        <div class="col-md-4 col-sm-4 col-lg-4 col-xs-4">
          <label>تاریخ تولد</label>
          <br>
          <!-- <div class="icon-position">
              <i class="icon_calendar icon"></i>
            </div>
            <input
              type="text"
              class="form-control"
              @blur="$v.data.birthdate.$touch()"
              :class="{ invalid: $v.data.birthdate.$error }"
              v-datepicker
              :value="convertDate(data.birthdate)"
              @change="data.birthdate = $event.detail.GregorianDate"
            />  -->
          <date-picker v-model="data.birthdate" :class="{ invalid: $v.data.birthdate.$error }"
            display-format="jYYYY/jMM/jDD" color="#00C3E1" popover="bottom-right" auto-submit locale="fa" />

          <p class="text-danger" v-if="!$v.data.birthdate.required && $v.data.birthdate.$dirty">
            لطفا تاریخ تولد را وارد کنید
          </p>
        </div>
        <div class="col-md-4">
          <div class="select">
            <select class="select-text" v-model="data.gender">
              <option v-for="item in genderItems" :value="item.key" :key="item.key">
                {{ item.value }}
              </option>
            </select>

            <span class="select-highlight"></span>
            <span class="select-bar"></span>
            <p class="text-danger" v-if="!$v.data.gender.required && $v.data.gender.$dirty">
              لطفا جنسیت را انتخاب نمائید
            </p>
            <label class="select-label">جنسیت</label>
          </div>
        </div>
      </div>



      <div class="row">
        <div class="col-md-4">
          <div class="group_mdi">
            <input type="text" v-model="data.passportNumber" />
            <span class="highlight"></span>
            <span class="bar"></span>
            <label>شماره پاسپورت</label>
          </div>
        </div>
        <div class="col-md-4">
          <div class="group_mdi">
            <input type="text" v-model="data.visaNumber" />
            <span class="highlight"></span>
            <span class="bar"></span>
            <label>شماره ویزا</label>
          </div>
        </div>
        <div class="col-md-4">
          <div class="group_mdi">
            <input type="text" v-model="data.jobTitle" />
            <span class="highlight"></span>
            <span class="bar"></span>
            <label>عنوان شغل</label>
          </div>
        </div>
      </div>


      <div class="row">
        <div class="col-md-4">
          <div class="select">
            <select class="select-text" v-model="profileModel.title">
              <option v-for="item in titleItems" :value="item.key" :key="item.key">
                {{ item.value }}
              </option>
            </select>
            <span class="select-highlight"></span>
            <span class="select-bar"></span>
            <label class="select-label">عنوان شما برای مکاتبات</label>
          </div>
        </div>
        <div class="col-md-4">
          <div class="select">
            <select class="select-text" v-model="countryId" @change="getStates(countryId)">
              <option v-for="item in country" :value="item.id" :key="item.name">
                {{ item.name }}
              </option>
            </select>
            <span class="select-highlight"></span>
            <span class="select-bar"></span>
            <label class="select-label">کشور</label>
          </div>
        </div>
        <div class="col-md-4">
          <div class="select">
            <select class="select-text" v-model="stateId" @change="getCites(stateId)">
              <option v-for="item in states" :value="item.id" :key="item.name">
                {{ item.name }}
              </option>
            </select>
            <span class="select-highlight"></span>
            <span class="select-bar"></span>
            <label class="select-label">استان</label>
          </div>
        </div>
        <div class="col-md-4">
          <div class="select">
            <select class="select-text" v-model="profileModel.nationalityId">
              <option v-for="item in cites" :value="item.id" :key="item.name">
                {{ item.name }}
              </option>
            </select>
            <span class="select-highlight"></span>
            <span class="select-bar"></span>
            <label class="select-label">شهر</label>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="group_mdi">
            <textarea class="style-textarea" placeholder="توضیحات" type="text" rows="4"
              v-model="profileModel.description" />
            <span class="highlight"></span>
            <span class="bar"></span>

          </div>
        </div>
      </div>

      <hr />

      <div class="btn-align">
        <button type="submit" class="btn btn-primary" @click.prevent="UpdateIndividual()" :disabled="$v.$invalid"
          :class="{ disabledBtn: $v.$invalid }">
          ثبت
        </button>
      </div>
    </form>
  </section>
</template>


<script>
import Store from "@/views/profile/store/index";
import moment from "moment-jalaali";
import {
  required,
  email,
  maxLength,
  minLength,
} from "vuelidate/lib/validators";

export default {
  name: "PersonalInfo",
  store: Store,
  validations: {
    data: {
      firstName: { required },
      lastName: { required },
      cellPhoneNumber: {
        required,
        maxLength: maxLength(11),
        minLength: minLength(11),
      },
      email: { required, email, maxLength: maxLength(100) },
      nationalNumber: {
        required,
        maxLength: maxLength(10),
        minLength: minLength(10),
      },
      birthdate: { required },
      gender: { required },
      nationalNumber: {
        required,
        checkMelliCode: (meli_code) => {
          if (meli_code != "") {
            if (meli_code != undefined) {
              if (meli_code.length == 10) {
                if (
                  meli_code == "1111111111" ||
                  meli_code == "0000000000" ||
                  meli_code == "2222222222" ||
                  meli_code == "3333333333" ||
                  meli_code == "4444444444" ||
                  meli_code == "5555555555" ||
                  meli_code == "6666666666" ||
                  meli_code == "7777777777" ||
                  meli_code == "8888888888" ||
                  meli_code == "9999999999"
                ) {
                  return false;
                }
                var c = parseInt(meli_code.charAt(9));
                var n =
                  parseInt(meli_code.charAt(0)) * 10 +
                  parseInt(meli_code.charAt(1)) * 9 +
                  parseInt(meli_code.charAt(2)) * 8 +
                  parseInt(meli_code.charAt(3)) * 7 +
                  parseInt(meli_code.charAt(4)) * 6 +
                  parseInt(meli_code.charAt(5)) * 5 +
                  parseInt(meli_code.charAt(6)) * 4 +
                  parseInt(meli_code.charAt(7)) * 3 +
                  parseInt(meli_code.charAt(8)) * 2;
                var r = n - parseInt(n / 11) * 11;
                if (
                  (r == 0 && r == c) ||
                  (r == 1 && c == 1) ||
                  (r > 1 && c == 11 - r)
                ) {
                  return true;
                } else {
                  return false;
                }
              } else {
                return false;
              }
            } else {
              return false;
            }
          } else {
            return false;
          }
        },
      },
    },
  },

  data: function () {
    return {
      profileModel: {
        id: "",
        name: "string",
        englishName: "",
        nationalityId: null,
        timeZone: "",
        logo: "",
        description: "",
        title: "",
      },

      data: {
        id: "",
        profileId: "",
        firstName: "",
        lastName: "",
        cellPhoneNumber: "",
        email: "",
        fatherName: "",
        passportNumber: "",
        visaNumber: "",
        nationalNumber: "",
        jobTitle: "",
        birthdate: moment(new Date()).format("jYYYY/jMM/jDD"),
      },
      now: moment(),
      genderItems: [
        { key: 1, value: "مرد" },
        { key: 2, value: "زن" },
      ],
      titleItems: [
        { key: 1, value: "خانم" },
        { key: 2, value: "آقا" },
        { key: 3, value: "مهندس" },
        { key: 4, value: "دکتر " },
      ],

      checknationalNumberValid: true,
      country: [],
      states: [],
      cites: [],
      countryId: "",
      stateId: "",

      image: "",
    };
  },

  mounted: function () {
    this.getUserId();
    this.getAllCountry();
  },
  computed: {},

  methods: {

    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage(file) {
      var reader = new FileReader();
      var _URL = window.URL || window.webkitURL;

      reader.onload = (e) => {
        if (file.size > 15000) {
          // alert("حجم فایل بیشتر از اندازه تعیین شده است");
          this.$toast.error("حجم فایل بیشتر از اندازه تعیین شده است", {
            position: "top-center",
            timeout: 4500,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 1.59,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            icon: true,
            rtl: true,
          });
          return;
        }
        this.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImage: function () {
      this.image = "";
    },

    async fetchData(id) {
      this.data = await this.$store.dispatch("getIndividualProfileData", id);
      this.data.id = this.data.individualId;
      this.image = this.data.logo
        ? "data:image/jpeg;base64," + this.data.logo
        : (this.image = "");

      this.$store.state.profileId = this.data.profileId;
      this.profileModel = {
        englishName: this.data.englishName,
        name: "",
        nationalityId: this.data.nationalityId,
        timeZone: this.data.timeZone,
        logo: this.data.logo,
        id: this.profileModel.id,
        description: this.profileModel.description,
        title: this.data.title,
      };
      if (this.profileModel.nationalityId != null) {
        this.getLocationById(this.profileModel.nationalityId).then((res) => {
          this.getCites(res.parentLocationId);

          this.getLocationById(res.parentLocationId).then((response) => {
            this.getStates(response.parentLocationId);
            this.stateId = response.id;

            this.getLocationById(response.parentLocationId).then((response) => {
              this.getAllCountry();
              this.countryId = response.id;
            });
          });
        });
      }
    },

    getUserId() {
      this.$store.dispatch("getUserId").then(() => {
        this.profileModel.id = this.$store.getters.GetUserId;
        this.fetchData(this.profileModel.id);
      });
    },

    getAllCountry() {
      this.$store.dispatch("getAllCountry").then((res) => {
        this.country = res;
        if (res.length == 0) this.profileModel.nationalityId = null;
        else {
          this.countryId = this.country.where((p) => p.name == "ایران")[0].id;
          this.getStates(this.countryId);
        }
      });
    },
    getStates(id) {
      this.$store.dispatch("getLocationByParentId", id).then((res) => {
        this.states = res;
        if (res.length == 0) {
          this.cites = [];
          this.profileModel.nationalityId = null;
        }
      });
    },
    getCites(id) {
      this.$store.dispatch("getLocationByParentId", id).then((res) => {
        this.cites = res;
        if (res.length == 0) this.profileModel.nationalityId = null;
      });
    },
    async getLocationById(id) {
      return await this.$store.dispatch("getLocationById", id);
    },

    convertDate(date) {
      if (date === "0001-01-01T00:00:00") return "";
      if (!moment(date).isValid()) return "";
      const pdate = moment(date).format("jYYYY/jMM/jDD");
      return pdate;
    },

    UpdateIndividual() {
      this.checknationalNumberValid = true;
      this.profileModel.logo = this.image.split(",")[1];

      this.$store
        .dispatch("UpdateProfileIndividual", {
          profileModel: this.profileModel,
          individualModel: this.data,
        })
        .then((res) => {
          if (res.status == 200) {
            // alert("ویرایش اطلاعات با موفقیت انجام گردید");
            this.$toast.success("ویرایش اطلاعات با موفقیت انجام گردید", {
              position: "top-center",
              timeout: 4500,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 1.59,
              showCloseButtonOnHover: false,
              hideProgressBar: false,
              icon: true,
              rtl: true,
            });
          }
        });
    },

    goBackToList() {
      this.$router.push({ name: "userBusinessList" });
    },

    handleImage(e) {
      const selectedImage = e.target.files[0];
      this.createBase64Image(selectedImage);
    },
    createBase64Image(fileObject) {
      const reader = new FileReader();

      reader.onload = (e) => {
        this.image = e.target.result;
      };
      reader.readAsDataURL(fileObject);
    },
  },
};
</script>
<style>
h4 {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
  line-height: 1.2;
  -webkit-font-smoothing: antialiased;
  color: #333;
  font-size: 18px;
}

ul {
  display: block;
  list-style-type: disc;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 40px;
}

li {
  display: list-item;
  text-align: -webkit-match-parent;
}

.img-fluid.styled {
  margin-top: 20px;
  border: 5px solid#fff !important;
  -webkit-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
}

.profile_pic {
  float: right;
  margin-bottom: 15px;
}

.user-avatar-uploader {
  display: flex;
  margin-bottom: 20px;
}

.user-avatar-uploader img {
  width: 80px;
  height: 80px;
  border-radius: 100%;
  border: 1px solid #dce4ed;
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.profile-earlier .profile-earlier-item {
  align-self: center;
  position: relative;
}

.profile-earlier .profile-earlier-item::before {
  content: " ";
  position: absolute;
  width: 8px;
  height: 8px;
  border: 3px solid #fcbe2f;
  right: -2px;
  top: 35%;
  border-radius: 10px;
}

.profile-earlier .profile-earlier-item.email::before {
  right: 15px !important;
}

.profile-earlier .profile-earlier-item.email {
  padding-right: 25px !important;
}

.card-stats .card-body {
  padding-top: 40px;
}

.group_mdi .highlight {
  height: 60%;
  width: 70%;
  top: 20%;
}

ul#profile_summary {
  margin: 10px 0 20px 0;
  padding: 0;
  list-style: none;
  text-transform: uppercase;
  font-weight: 600;
}

ul#profile_summary li {
  padding: 4px 0;
  position: relative;
}

ul#profile_summary li span {
  text-transform: none;
  font-weight: normal !important;
  position: absolute;
  left: 200px !important;
  direction: ltr;
}

ul#profile_summary li:nth-child(odd) {
  background-color: #fff;
}

ul#profile_summary li:nth-child(even) {
  background-color: #f8f8f8;
}

ul#profile_summary li span {
  left: 0 !important;
}

.inputContainer i {
  position: absolute;
}

.inputContainer {
  width: 100%;
  margin-bottom: 10px;
}

.icon-custom {
  margin-top: 40px !important;
  text-align: left !important;
  float: left;
}

.img-icon {
  font-size: 24px;
  margin-right: -10px;
  color: rgb(0, 132, 137);
}

.img-icon label {
  line-height: 3;
  padding: 5px 20px;
  margin-right: -30px;
  cursor: pointer;
}

.icon-position {
  float: left;
  margin-left: 26px;
}

.dashboard-top-status form {
  margin: 30px 5px;
  border-top: 1px solid #ccdae9;
  padding: 20px 5px;
}

</style>
